import { Maybe, NfcCard } from 'graphql/generated/graphqlTypes';
import { cardsVar } from 'state/vars';

export const setCardsAction = (cards: NfcCard[]) => {
  cardsVar(cards);
};

export const updateCardsAction = (updatedCard: Maybe<NfcCard> | undefined) => {
  const currentCards = cardsVar();
  const updatedCards = currentCards?.map((card) => {
    if (card.uuid === updatedCard?.uuid) {
      return updatedCard;
    }
    return card;
  });

  cardsVar(updatedCards);
};
